import React from 'react'
import Hero from './Comp/Hero/Hero'
import WhyChooseUs from './Comp/WhyChooseUs/WhyChooseUs'
import GetStarted from './Comp/GetStarted/GetStarted'

export default function Manufacturers() {
    return (
        <>
            <Hero />
            <WhyChooseUs />
            <GetStarted />
        </>
    )
}
